const checkPageRange = (page, currentPage, totalPages) => (currentPage <= 2 && page <= currentPage + 2) ||
    (currentPage >= totalPages - 1 && page >= totalPages - 3);
export const shouldRenderPage = (page, currentPage, totalPages) => (page < currentPage && page >= currentPage - 1) ||
    (page <= currentPage + 1 && page > currentPage) ||
    checkPageRange(page, currentPage, totalPages);
//# sourceMappingURL=shouldRenderPage.js.map